import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { VxButtonComponent } from '@ui/button/button.component';
import { VxIconComponent } from '@ui/icon/icon.component';
import { VxIconButtonComponent } from '@ui/icon-button/icon-button.component';
import { VxTooltipDirective } from '@ui/tooltip/tooltip.directive';
import { LocaleDatePipe } from 'src/app/core/pipes/locale-date.pipe';
import { IncidentToastSnoozeService } from 'src/app/store/incident-activity/incident-toast-snooze.service';

/**
 * Sidebar notice while incident toasts are snoozed (from a toast's menu):
 * what is snoozed and until when, plus Resume. The collapsed rail shows just
 * a bell-slash button that resumes.
 */
@Component({
  selector: 'app-toast-snooze-indicator',
  templateUrl: './toast-snooze-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LocaleDatePipe,
    TranslocoModule,
    VxButtonComponent,
    VxIconButtonComponent,
    VxIconComponent,
    VxTooltipDirective,
  ],
})
export class ToastSnoozeIndicatorComponent {
  protected readonly snooze = inject(IncidentToastSnoozeService);

  readonly compact = input(false);

  protected readonly active = computed(
    () =>
      !!this.snooze.allSnoozedUntil() || this.snooze.snoozedIncidentCount() > 0
  );

  /** "until 14:30" today; with the date once the end is on another day
   *  ("until tomorrow" ends at 08:00 the next morning). */
  protected readonly untilStyle = computed(() =>
    this.snooze.allSnoozedUntil()?.toDateString() === new Date().toDateString()
      ? 'time'
      : 'datetime'
  );
}
